'use strict';
import {EwSiteApp} from "../../app/ewsiteapp.js";
import {StructureSectionsNavigCtrl} from "./structuresectionsnavigctrl.js";
EwSiteApp.controller('StructureSectionsNavigCtrl', ["$scope", "jsDataService", StructureSectionsNavigCtrl]);
import {InvitationStructureSectionsNavigCtrl} from "./invitationsstructuresectionsnavigctrl.js";
EwSiteApp.controller('InvitationStructureSectionsNavigCtrl', ["$scope", "jsDataService", InvitationStructureSectionsNavigCtrl]);

// section controllers
import {SectionBaseCtrl} from "./section_base_ctrl.js";
EwSiteApp.controller('SectionBaseCtrl', ["$scope", "$filter", "jsDataService", SectionBaseCtrl]);

import {SectionA1GeneralCtrl} from "./section_a1general_ctrl.js";
EwSiteApp.controller('SectionA1GeneralCtrl', ["$scope", "$filter", "jsDataService", SectionA1GeneralCtrl]);

import {SectionA2DeclarationsCtrl} from "./section_a2declarations_ctrl.js";
EwSiteApp.controller('SectionA2DeclarationsCtrl', ["$scope", "$filter", "jsDataService", SectionA2DeclarationsCtrl]);

import {SectionA3ParticipantsCtrl} from "./section_a3participants_ctrl.js";
EwSiteApp.controller('SectionA3ParticipantsCtrl', ["$scope", "$filter", "jsDataService", "$mdDialog", SectionA3ParticipantsCtrl]);

import {SectionA41WorkActivitiesCtrl} from "./section_a41workactivities_ctrl.js";
EwSiteApp.controller('SectionA41WorkActivitiesCtrl', ["$scope", "$filter", "jsDataService", "$mdDialog", SectionA41WorkActivitiesCtrl]);

import {SectionA42TimetableCtrl} from "./section_a42timetable_ctrl.js";
EwSiteApp.controller('SectionA42TimetableCtrl', ["$scope", "$filter", "jsDataService", SectionA42TimetableCtrl]);

import {SectionA5TocCtrl} from "./section_a5toc_ctrl.js";
EwSiteApp.controller('SectionA5TocCtrl', ["$scope", "$filter", "jsDataService", "$mdDialog", SectionA5TocCtrl]);

import {SectionA6BudgetCtrl} from "./section_a6budget_ctrl.js";
EwSiteApp.controller('SectionA6BudgetCtrl', ["$scope", "$filter", "jsDataService", SectionA6BudgetCtrl]);

import {SectionB1RelevanceCtrl} from "./section_b1relevance_ctrl.js";
EwSiteApp.controller('SectionB1RelevanceCtrl', ["$scope", "$filter", "jsDataService", SectionB1RelevanceCtrl]);

import {SectionB2QualityCtrl} from "./section_b2quality_ctrl.js";
EwSiteApp.controller('SectionB2QualityCtrl', ["$scope", "$filter", "jsDataService", "$mdDialog", SectionB2QualityCtrl]);

import {SectionB3ImpactCtrl} from "./section_b3impact_ctrl.js";
EwSiteApp.controller('SectionB3ImpactCtrl', ["$scope", "$filter", "jsDataService", SectionB3ImpactCtrl]);

import {SectionBAnnexesCtrl} from "./section_bannexes_ctrl.js";
EwSiteApp.controller('SectionBAnnexesCtrl', ["$scope", "$filter", "jsDataService", "notify", "$mdDialog", SectionBAnnexesCtrl]);

// END OF section controllers

import {MembersCtrl} from "./members_ctrl.js";
EwSiteApp.controller('MembersCtrl', ["$scope", "$filter", "jsDataService", "$mdDialog", MembersCtrl]);

import {ChangeLogListCtrl} from "./changeloglistctrl.js";
EwSiteApp.controller('ChangeLogListCtrl', ["$scope", "$http", "$filter", "$timeout", "$locale", "jsDataService", ChangeLogListCtrl]);

import {InvitationChangeLogListCtrl} from "./invitationchangeloglistctrl.js";
EwSiteApp.controller('InvitationChangeLogListCtrl', ["$scope", "$http", "$filter", "$timeout", "$locale", "jsDataService", InvitationChangeLogListCtrl]);

import {DatasheetSectionsNavigCtrl} from "./datasheetsectionsnavigctrl.js";
EwSiteApp.controller('DatasheetSectionsNavigCtrl', ["$scope", "jsDataService", DatasheetSectionsNavigCtrl]);

import {ReportingSectionsNavigCtrl} from "./reportingsectionsnavigctrl.js";
EwSiteApp.controller('ReportingSectionsNavigCtrl', ["$scope", "jsDataService", ReportingSectionsNavigCtrl]);
